import type { SignalId } from '@/scatterPlot/scatterPlot.constants';
import type { Extremes } from 'other_components/highcharts';
import { flatMap } from 'lodash';

export function axesToYs(axes: Highcharts.Axis[] | Highcharts.Axis): Record<SignalId, Extremes> {
  const normalizedAxes = flatMap([axes]);
  const ys: Record<SignalId, Extremes> = {};
  normalizedAxes.forEach((axis) => {
    const signalId = axis.userOptions.signalId as SignalId;
    ys[signalId] = {
      min: axis.min as number | null,
      max: axis.max as number | null,
    };
  });
  return ys;
}
